import { useEffect, useRef, useState } from 'react';
import { useStore } from '../../../utils/store';
import { useNavigate } from 'react-router-dom';
import SwitchComponent from '../../../components/SwitchComponent';
import Constants from '../../../utils/constants';
import HttpService from '../../../services/HttpService';
import StatusRequestData from '../../../Models/StatusRequest';
import { useSearch } from '../../../components/searchContext';
import { Box, Paper, Stack, Typography, SortDirection } from '@mui/material';
import AddButtonComponent from '../../../components/form/AddButtonComponent';
import CustomPaginationActionsTable from '../../../components/TablePagination';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import { useAlert } from '../../../components/alertContext';

const MobileAssets: React.FC = () => {
  const { searchQuery } = useSearch();
  const isInitialLoad = useRef(true);
  const { getAdmin } = useStore();
  const navigate = useNavigate();
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const columns: any[] = [
    {
      field: 'assetNumber',
      headerName: 'Asset #',
    },
    {
      field: 'assetName',
      headerName: 'Asset Name',
    },
    {
      field: 'registrationDate',
      headerName: 'Registration Due Date',
    },
    {
      field: 'nextServiceDate',
      headerName: 'Next Service Date',
    },
    {
      field: 'assetType',
      headerName: 'Asset Type',
    },
    {
      field: 'isHired',
      headerName: 'Owned/Hired',
      renderCell: (value: any, row: any) =>
        value ? <span>Hired</span> : <span>Owned</span>,
    },
    {
      field: 'contractorName',
      headerName: 'Contractor',
    },
    {
      field: 'status',
      headerName: 'Status',
      disableSort: true,
      renderCell: (value: any, row: any) => (
        <SwitchComponent
          checked={value === '1' ? true : false}
          size="small"
          color={'success'}
          inputProps={{ 'aria-label': 'controlled' }}
          handleInputChange={() => {}}
          name={'statusSwitch'}
          value={value}
        />
      ),
    },
  ];

  const [paginate, setPaginate] = useState<any>({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const [rows, setRows] = useState<any>([]);
  const [orderBy, setOrderBy] = useState<any>('id');
  const [order, setOrder] = useState<SortDirection>('desc');
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };
  const clearForm = () => {
    navigate('/data-management/mobile-assets');
  };

  const statusUpdate = async (dataObj: StatusRequestData) => {
    try {
      const response = await HttpService.patch(
        `${Constants.apiURL}${Constants.mobileAssetsURL}`,
        dataObj,
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      if (response.success) {
        fetchData();
        clearForm();
      }
      console.log('PATCH Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const handleStatus = (row: any) => {
    let status = '1';
    if (row.status === '1') status = '0';
    if (row.status === '0') status = '1';
    statusUpdate({ id: row.id, status: status });
  };

  const handlePagination = (paginationData: any) => {
    console.log(paginationData);
    setPaginate(paginationData);
  };

  const fetchData = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL}${Constants.mobileAssetsURL}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        { search: searchQuery, limit: paginate.limit, offset: paginate.offset }
      );
      if (response.success) {
        setRows(response.data.paginateRecords);
        setTotalRecords(response.data.total);
        handleOrderBy('id');
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  useEffect(() => {
    if (isInitialLoad.current) {
      fetchData();
      isInitialLoad.current = false;
      return;
    }
    if (isInitialLoad.current === false && (searchQuery || paginate)) {
      fetchData();
    }
  }, [searchQuery, paginate]);

  return (
    <Stack>
      <Box className="main dashboardmain">
        <section className="section dashboard">
          <div className="containergrid">
            <div className="mt-2">
              <Paper sx={{ width: '100%' }} className="mt-4">
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px',
                    mb: 2,
                  }}
                >
                  <Typography variant="h6">Mobile Assets</Typography>
                  <AddButtonComponent
                    onClick={() => {
                      navigate('/data-management/mobile-assets/Add');
                    }}
                    keyName="checkIcon"
                    label="Add new"
                  />
                </Box>
                <CustomPaginationActionsTable
                  rows={rows}
                  columns={columns}
                  totalRecords={totalRecords}
                  handlePagination={handlePagination}
                  handleRowClick={(row) => {
                    navigate('/data-management/mobile-assets/' + row.id);
                    //console.log(data);
                  }}
                  paginationModel={{
                    page: paginate.offset,
                    pageSize: paginate.limit,
                  }}
                  handleStatus={handleStatus}
                  order={order}
                  orderBy={orderBy}
                  handleOrderBy={handleOrderBy}
                />
              </Paper>
            </div>
          </div>
        </section>
      </Box>
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Stack>
  );
};

export default MobileAssets;
